import { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import CanvasAddProductButton from "../../../sharable/CanvasAddProductButton";
import EncarteProduct from "../../../sharable/EncarteProduct/EncarteProduct";
import EncarteTrialVersionMarketingMessage from "../../../sharable/EncarteTrialVersionMarketingMessage";
import { ExpirationDateStyle } from "../../../sharable/ExpirationDate";
import { rgbaToHex } from "../../../sharable/PickerAndSelector";
import StoriesPanfletoFooterStyles, {
  getStoriesFooterRowHeight,
  useFooterNotice,
} from "../../../sharable/SocialCanvasFooterStyles";
import { BRAND_VIEW } from "../../ToolBarMenuViews/Toolbar";
import WorkspaceContext from "../../WorkspaceContext";
import {
  BrandLogo,
  calcProductStylesOcurrence,
  Canvas,
  Footer,
  GridProducts,
  Header,
} from "../Canvas/CanvasGeneralStyles";
import {
  CANVAS_TARGET_CLASSNAME,
  LOGO_SIZE_SMALL,
  MAX_PRODUCTS_STORIES_FORMAT,
  STORIES_DIM,
} from "../EncarteConstants";

const StoriesCanvasContainer = styled(Canvas)`
  ${ExpirationDateStyle} {
    width: 100%;
    margin: 0;
    height: min-content !important;
    text-align: center;
  }
`;
const StoriesHeader = styled(Header)``;
const StoriesGridProducts = styled(GridProducts)``;
export const StoriesFooter = styled(Footer)`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  ${({ styles }) => css`
    background-color: ${rgbaToHex(styles?.bgColor, 0.75)};
    background-image: none;
  `}

    width: 100%;
    border-radius: 0;
    font-weight: bold;
  }
`;

export const BrandNamePhraseWrapper = styled.div`
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #0c0c0c93;
  color: #fff;
  ${({ canvasScale, userBrand, styles }) => css`
    border-bottom-right-radius: ${50 * canvasScale}px;

    h2 {
      font-size: ${userBrand.name && userBrand.name.length > 20
        ? 25 * canvasScale
        : 30 * canvasScale}px;
      text-transform: capitalize;
    }
    p {
      font-size: ${userBrand.name && userBrand.name.length > 20
        ? 24 * canvasScale
        : 18 * canvasScale}px;
      margin-bottom: ${10 * canvasScale}px;
      font-weight: bold;
      margin-top: 0;
      font-style: italic;
      text-stroke: 1px black;
    }
  `}
`;

export const BrandNameAdressContactsWrapper = styled.div`
  display: grid;
  grid-template-columns: 40% 60%;
  height: 100%;
`;

export const AddressContactsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export default function StoriesCanvas({
  products,
  grid,
  isTargetCanvas,
  canvasScale,
  isProductClickable,
}) {
  const { styles, userBrand, encarte, model, scrollIntoMenu } =
    useContext(WorkspaceContext);
  const [headerAndFooterStyles, setHeaderAndFooterStyles] = useState({});
  useEffect(() => {
    if (products?.length === 0) {
      setHeaderAndFooterStyles(null);
      return;
    }
    setHeaderAndFooterStyles(calcProductStylesOcurrence(products));
  }, [products]);

  const footerNotice = useFooterNotice();
  const storiesFooterRowHeight = getStoriesFooterRowHeight(
    styles.footerStyle,
    canvasScale,
    Boolean(footerNotice),
  );
  return (
    <StoriesCanvasContainer
      canvasScale={canvasScale}
      styles={styles}
      model={model}
      dimensions={STORIES_DIM}
      className={isTargetCanvas && CANVAS_TARGET_CLASSNAME}
      footerRowHeight={storiesFooterRowHeight}
    >
      <StoriesHeader>
        <BrandLogo
          logo={userBrand.logoURLTmp}
          canvasScale={canvasScale}
          logoSize={styles.logoSize}
          logoStyle={styles.logoStyle}
          headerStyles={headerAndFooterStyles}
          onClick={() => {
            if (isProductClickable) scrollIntoMenu(BRAND_VIEW);
          }}
          position={{ bottom: 10, right: 10 }}
          size={LOGO_SIZE_SMALL}
        />
      </StoriesHeader>
      {products?.length > 0 ? (
        <>
          <StoriesGridProducts
            grid={grid}
            styles={styles}
            canvasScale={canvasScale}
          >
            {products
              .slice(0, MAX_PRODUCTS_STORIES_FORMAT)
              .map((product, i) => (
                <EncarteProduct
                  product={product}
                  canvasScale={canvasScale}
                  styles={styles}
                  index={i}
                  isProductClickable={isProductClickable}
                  productsLength={products.length}
                />
              ))}
          </StoriesGridProducts>
          {/* <EncarteTrialVersionMarketingMessage canvasScale={canvasScale} /> */}
        </>
      ) : (
        <CanvasAddProductButton dimensions={STORIES_DIM} />
      )}

      {headerAndFooterStyles && (
        <StoriesPanfletoFooterStyles
          headerAndFooterStyles={headerAndFooterStyles}
          canvasScale={canvasScale}
        />
      )}
    </StoriesCanvasContainer>
  );
}
